import type { FooterLink } from './types';

export const institutionalLinks: FooterLink[] = [
  { label: 'Site SouJunior', to: 'https://www.soujunior.tech/' },
  { label: 'Indique uma vaga', to: '#', disabled: true },
  { label: 'Faça parte', to: 'https://www.soujunior.tech/?#participation' },
  { label: 'Ouvidoria', to: 'https://www.soujunior.tech/ouvidoria' },
];
